import { faCircleCheck, faQuestionCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { TeamApprovalStatus } from '@/components/constants/enums';

interface TeamApprovalStatusProps {
	status: TeamApprovalStatus;
}

export default function TeamApprovalStatusIcon({ status }: TeamApprovalStatusProps) {
	const renderIcon = () => {
		switch (status) {
			case TeamApprovalStatus.APPROVED:
				return <FontAwesomeIcon icon={faCircleCheck} className="size-4 text-[#12B76A] " />;
			case TeamApprovalStatus.PENDING:
				return <FontAwesomeIcon icon={faQuestionCircle} className="size-4 text-[#FDB022] " />;

			default:
				return null;
		}
	};

	return <>{renderIcon()}</>;
}
